export default __webpack_public_path__ + "static/media/IMG-20240708-WA0026.ec7b4400.jpg";